import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './shared/layout/header/header.component';
import { FooterComponent } from './shared/layout/footer/footer.component';
import { CentralService } from './services/central.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
            CommonModule, 
            RouterOutlet, 
            RouterLink, 
            RouterLinkActive, 
            HeaderComponent, 
            FooterComponent
          ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'medclass';
  isSessionActive: boolean = false;
  webinarActivo:any = false;  

  constructor(private router: Router,
              private service: CentralService,
              private centralService: CentralService) {}

  private forceReloadFromRootToInicio(): boolean {
    if (window.location.pathname === '/' && !window.location.search && !window.location.hash) {
      window.location.replace('/inicio');
      return true;
    }

    return false;
  }

  ngOnInit() {
    if (this.forceReloadFromRootToInicio()) {
      return;
    }

    if (this.service.tieneToken()) {
      this.service.isLoggedIn().subscribe((valid) => {
        this.isSessionActive = valid === true;
      });
    }

    this.router.events.subscribe((event) => {
      const currentUrl = window.location.href;

      const areaPersistente = currentUrl.includes('contenido') || 
                              currentUrl.includes('masterclasses') || 
                              currentUrl.includes('sesiones') || 
                              currentUrl.includes('capsulas') || 
                              currentUrl.includes('podcasts') ||
                              currentUrl.includes('shorts')
      if (event instanceof NavigationEnd) {
        // console.log('EVENTO NAVEGACION', areaPersistente);
        this.isSessionActive = this.checkIfSessionIsActive();

        if (areaPersistente) {
          // console.log(' M A N T I E N E ');
          console.log(this.centralService.navegacionAreaTerapeutica);
        }else{
          // console.log('reset');
          this.centralService.resetAreaTerapeutica();
        }

        if (!currentUrl.includes('webinar')) {
          this.service.getWebinarActivo().subscribe((res:any) =>{
            if (res[0]) {
              if (res[0].webinarActivo) {
                this.webinarActivo = res[0];
              }else{
                this.webinarActivo = false;
              }
            }
          })
        }
      }
    });
  }

  checkIfSessionIsActive(): boolean {
    const token = localStorage.getItem('token');
    return token !== null && token !== undefined;
  }
}
